
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lending",
      function () {
        return require("private-next-pages/lending.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lending"])
      });
    }
  